import { ContainerComponent, wrap } from 'AppReact';
import { NotPaddedGrowWrapper, DataTableWrapper, TBodyWrapper, TableRow, Td, Mr5 } from 'wrappers';
import { DataTableHeader, TableFooter } from 'containers';
import controller from './controller';
import cellSwitch from './cellSwitch';
import internalState from './internalState';

export const definition = {
  name: 'Table',
  controller,
  props: { ...internalState },
  initialProps: ({ header, rows, orderBy, orderDirection, total, pageSize, pageNumber, clickable }) => {
    return { header, rows, orderBy, orderDirection, total, pageSize, pageNumber, clickable };
  },
  elements: [
    {
      wrapper: wrap(DataTableWrapper, NotPaddedGrowWrapper),
      displayState: ({ clickable }) => ({ clickable }),
      name: 'Table',
      elements: [
        {
          component: DataTableHeader,
          name: 'Header',
          bindings: ({ orderBy, orderDirection, header }) => ({ orderBy, orderDirection, content: header })
        },
        {
          wrapper: TBodyWrapper,
          name: 'Body',
          elements: [
            {
              wrapper: TableRow,
              isListOf: 'rows',
              isButton: true,
              bindings: ({ row, clickable }) => ({ row, clickable }),
              displayState: ({ clickable }) => ({ clickable }),
              name: 'Row',
              elements: [
                {
                  wrapper: wrap(Mr5, Td),
                  name: 'Cell',
                  isListOf: { cell: ({ row }) => row },
                  elements: [
                    {
                      componentSelect: cellSwitch,
                      name: 'CellContent',
                      displayValue: ({ cell }) => cell.values[0].toString(),
                      bindings: ({ cell }) => {
                        if (cell.keys?.length > 0) {
                          const combinedValues = { ...cell };
                          cell.keys.forEach((key, index) => {
                            combinedValues[key] = cell.values[index];
                          });
                          return combinedValues;
                        }
                        return cell;
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'Footer',
      component: TableFooter,
      bindings: ({ pageSize, pageNumber, total }) => ({ pageSize, pageNumber, total })
    }
  ]
};

export default ContainerComponent(definition);
